import { Component, OnInit, ViewChild, Input, EventEmitter, Output, ChangeDetectorRef, SimpleChanges } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { LandingConstants } from '../Constant/landing-constants';
import { LandingCardInterface } from '../Interfaces/landing-card';
import { UserSelectionsService } from '../Services/user-selections.service';
import { SnapshotService } from '../Services/snapshot.service';
import { Observable, map } from 'rxjs';
import { CommonChartmoduleService } from '../Services/common-chartmodule.service';
import { LoaderService } from 'src/app/common/services/loader.service';
import { SnapshotSharedVariablesService } from '../Services/snapshot-shared-variables.service';
import { ChartSelectWidgetLibraryComponent } from '../chart-select-widget-library/chart-select-widget-library.component';
import { CustomsnapshotService } from '../Services/customsnapshot.service';

@Component({
  selector: 'app-left-panel-widget-library',
  templateUrl: './left-panel-widget-library.component.html',
  styleUrls: ['./left-panel-widget-library.component.scss']
})



export class LeftPanelWidgetLibraryComponent implements OnInit {
  expandableMenu = false;
  // availableCharts = LandingConstants.availableCharts;
  @Input() chartDisplayName: string = "";
  @Input() chartId: any;
  @Input() selectedChartDetails: any;
  @Input() selectedSnapshotData: any | undefined;
  @Input() availableCharts: any = [];
  @Output() onChartClick = new EventEmitter<string>();
  @ViewChild(RouterOutlet, { static: false }) outlet!: RouterOutlet;
  constructor(private router: Router, private userSelectionServiceObj: UserSelectionsService, private _configService: SnapshotService, private cdr: ChangeDetectorRef
    , private commonChartModule: CommonChartmoduleService, private _loaderService: LoaderService,
    private clientDetails: SnapshotSharedVariablesService,
    private snapshotDetails: SnapshotSharedVariablesService,
    private _configCustomService: CustomsnapshotService
  ) { }
  snapshotTypeData: any[] = [];
  snapshotTypeitem: any = [];
  show: boolean = false;
  widgetDetails: any;
  @Input() gotData: any;

  ngOnInit() {
     this.GetThisSnapshotData();
     this.availableCharts=[];
    //  this.updateChartSelectedNumber();

  }

  ngOnChanges(changes: SimpleChanges) {
    if ((changes['availableCharts'])) 
        this.updateChartSelectedNumber();

    event?.stopPropagation();
  }


  updateChartSelectedNumber() { // Declare widgetDetails as an array
    if ((this._configCustomService.widgetSaveObjectCustom.length != 0 && this._configCustomService.widgetSaveObjectCustom.length > 0)) {
      //this.widgetDetails = JSON.parse(localStorage.getItem('TotalwidgetDetailss') || ""); // Retrieve the JSON string from localStorage
      this.widgetDetails = this._configCustomService.widgetSaveObjectCustom;
      if (this.widgetDetails.length != undefined) {
        let snaphottypes = this.widgetDetails.find((w: any) => w.client_name == this._configService.clientName && w.snapshot_name == this.clientDetails.clientDetails.study);
        if (snaphottypes) {
          let snapshotType = snaphottypes.snapshotType.find((st: any) => st.snapshotType_name == this._configCustomService.selectedSnapshotType?.name);
          if (snapshotType) {
            let section = snapshotType.section.find((s: any) => s.section_name == this._configCustomService.selectedSection);
            if (section) {
              let subsection = section.subsection.find((sb: any) => sb.subsection_name == ((this._configCustomService.selectedSubsection == undefined || this._configCustomService.selectedSubsection == "") ? "NA" : this._configCustomService.selectedSubsection));
              if (subsection) {
                // widgetNames = subsection.widget_detail.map((widget: any) => widget.widget_name);
                // "widgetchart_name": "Vertical Bar Chart",
                //   "widgetParentChartType": "BarChart",
                // if (this.chunkedCharts[0]) {
                //   this.chunkedCharts[0].forEach((chart: any) => {
                //     let count = 0;
                //     if (this.widgetDetails.length > 0) {
                //       if (subsection.widget_detail != undefined)
                //         count = subsection.widget_detail.filter((m: any) => chart.chartTitle?.trim().replace(/\s+/g, '').toLowerCase() === m.widgetchart_name?.trim().replace(/\s+/g, '').toLowerCase()).length;
                //       //   else
                //       //     count = this.widgetDetails[0].WidgetDetail.filter((m: any) => chart.chartTitle?.trim().replace(/\s+/g, '').toLowerCase() === m.widgetchartname?.trim().replace(/\s+/g, '').toLowerCase()).length;

                //       //   if (this.widgetDetails[0].WidgetDetail == undefined && this.widgetDetails[0].WidgetDetail != undefined)
                //       //     count = this.widgetDetails[0].WidgetDetail.filter((m: any) => chart.chartTitle?.trim().replace(/\s+/g, '').toLowerCase() === m.widgetchartname?.trim().replace(/\s+/g, '').toLowerCase()).length;
                //       //   else if (this.widgetDetails[0].WidgetDetail != undefined && this.widgetDetails[0].WidgetDetail == undefined)
                //       //     count = this.widgetDetails[0].WidgetDetail.filter((m: any) => chart.chartTitle?.trim().replace(/\s+/g, '').toLowerCase() === m.widgetchartname?.trim().replace(/\s+/g, '').toLowerCase()).length;
                //     }
                //     chart.chartSelectedNumber = count > 0 ? count : 0;
                //   });
                // }
                // if (this.chunkedCharts[1]) {
                //   this.chunkedCharts[1].forEach((chart: any) => {
                //     let count = 0;
                //     if (this.widgetDetails.length > 0) {
                //       if (subsection.widget_detail != undefined)
                //         count = subsection.widget_detail.filter((m: any) => chart.chartTitle?.trim().replace(/\s+/g, '').toLowerCase() === m.widgetchart_name?.trim().replace(/\s+/g, '').toLowerCase()).length;
                //       //   else
                //       //     count = this.widgetDetails[0].WidgetDetail.filter((m: any) => chart.chartTitle?.trim().replace(/\s+/g, '').toLowerCase() === m.widgetchartname?.trim().replace(/\s+/g, '').toLowerCase()).length;

                //       //   if (this.widgetDetails[0].WidgetDetail == undefined && this.widgetDetails[0].WidgetDetail != undefined)
                //       //     count = this.widgetDetails[0].WidgetDetail.filter((m: any) => chart.chartTitle?.trim().replace(/\s+/g, '').toLowerCase() === m.widgetchartname?.trim().replace(/\s+/g, '').toLowerCase()).length;
                //       //   else if (this.widgetDetails[0].WidgetDetail != undefined && this.widgetDetails[0].WidgetDetail == undefined)
                //       //     count = this.widgetDetails[0].WidgetDetail.filter((m: any) => chart.chartTitle?.trim().replace(/\s+/g, '').toLowerCase() === m.widgetchartname?.trim().replace(/\s+/g, '').toLowerCase()).length;
                //     }
                //     chart.chartSelectedNumber = count > 0 ? count : 0;
                //   });
                // }
                this.availableCharts.forEach((chart: any) => {
                  let count = 0;
                  if (subsection.widget_detail != undefined){
                      let a = subsection.widget_detail.filter((m: any) => { 
                      if(m.widgetParentChartType.trim().replace(/\s+/g, '').toLowerCase() == "tableview")
                        return chart.displayName.trim().replace(/\s+/g, '').toLowerCase() === "others";
                      else 
                        return chart.displayName.trim().replace(/\s+/g, '').toLowerCase() === m.widgetParentChartType.trim().replace(/\s+/g, '').toLowerCase();
                      });
                      console.log(subsection.widget_detail);
                      count = a.length;
                  }
                  else
                    count = subsection.widget_detail.filter((m: any) => chart.displayName.trim().replace(/\s+/g, '').toLowerCase() === m.widgetParentChartType.trim().replace(/\s+/g, '').toLowerCase()).length;
                  chart.chartSelectedNumber = count > 0 ? count : 0;

                });
              }
              else {
                //   if (this.chunkedCharts[0]) {
                //     this.chunkedCharts[0].forEach((chart: any) => {
                //       let count = 0;
                //       if (this.widgetDetails.length > 0) {
                //         count = 0;
                //       }
                //       chart.chartSelectedNumber = count > 0 ? count : 0;
                //     });
                //   }
                //   if (this.chunkedCharts[1]) {
                //     this.chunkedCharts[1].forEach((chart: any) => {
                //       let count = 0;
                //       if (this.widgetDetails.length > 0) {
                //         if (subsection.widget_detail != undefined)
                //           count = subsection.widget_detail.filter((m: any) => chart.chartTitle?.trim().replace(/\s+/g, '').toLowerCase() === m.widgetchart_name?.trim().replace(/\s+/g, '').toLowerCase()).length;
                //         //   else
                //         //     count = this.widgetDetails[0].WidgetDetail.filter((m: any) => chart.chartTitle?.trim().replace(/\s+/g, '').toLowerCase() === m.widgetchartname?.trim().replace(/\s+/g, '').toLowerCase()).length;

                //         //   if (this.widgetDetails[0].WidgetDetail == undefined && this.widgetDetails[0].WidgetDetail != undefined)
                //         //     count = this.widgetDetails[0].WidgetDetail.filter((m: any) => chart.chartTitle?.trim().replace(/\s+/g, '').toLowerCase() === m.widgetchartname?.trim().replace(/\s+/g, '').toLowerCase()).length;
                //         //   else if (this.widgetDetails[0].WidgetDetail != undefined && this.widgetDetails[0].WidgetDetail == undefined)
                //         //     count = this.widgetDetails[0].WidgetDetail.filter((m: any) => chart.chartTitle?.trim().replace(/\s+/g, '').toLowerCase() === m.widgetchartname?.trim().replace(/\s+/g, '').toLowerCase()).length;
                //       }
                //       chart.chartSelectedNumber = count > 0 ? count : 0;
                //     });
                //   }
                // }
                this.availableCharts.forEach((chart: any) => {
                  let count = 0;
                  if (subsection?.widget_detail != undefined)
                    count =0;
                  else
                    count =0;
                  chart.chartSelectedNumber = count > 0 ? count : 0;

                });
              }
            }
            else {
              this.availableCharts.forEach((chart: any) => {
                chart.chartSelectedNumber = 0;
              });
                // this.chunkedCharts[0].forEach((chart: any) => {
                //   let count = 0;
                //   if (this.widgetDetails.length > 0) {
                //     count = 0;
                //   }
                //   chart.chartSelectedNumber = count > 0 ? count : 0;
                // });
              }
            }
          }
        }
      }

      // if (this._configCustomService.widgetSaveObjectCustom.length > 0)
      //   this.widgetList = this._configCustomService.getVisualSelectWidgetDetails(this._configCustomService.widgetSaveObjectCustom[0], this._configCustomService.selectedSection, this._configCustomService.selectedSubsection == undefined ? "NA" : this._configCustomService.selectedSubsection, this._configCustomService.selectedSnapshotType?.name)
      this.cdr.detectChanges();
    }



    GetThisSnapshotData() {
      this._loaderService.showLoader();
      this._configService.snapshotSelectedName = this.clientDetails.clientDetails.study;
      this._configService.getClientStudyData({ client_code: this.clientDetails.clientDetails.client_name, snapshot_name: this.clientDetails.clientDetails.study }).subscribe(async (b: any) => {
        //  
        await this.getCustomProperties();
        if (b.body.Data != null && b.body.Data != undefined && b.body.Data != "") {
          let a = JSON.parse(b.body.Data).snapshotType_details;

          this._configService.snapshotTypeSelectedName = this._configService.snapshotTypeSelectedName == undefined || this._configService.snapshotTypeSelectedName == "" ? a[0].snapshot_type : this._configService.snapshotTypeSelectedName;

          a.forEach((item: any) => {
            if (item.snapshot_type == this._configService.snapshotTypeSelectedName)
              item.checked = true;
            else
              item.checked = false;
          });
          this.snapshotTypeitem = [];
          this.snapshotTypeitem.push({
            showDropDown: false,
            checkedList: this._configService.snapshotTypeSelectedName,
            options: a
          });

          this.selectedSnapshotType = this._configService.snapshotTypeSelectedName == undefined || this._configService.snapshotTypeSelectedName == "" ? a[0].snapshot_type : this._configService.snapshotTypeSelectedName;
          this.snapshotTypeitem = this.snapshotTypeitem;
          this.snapshotTypeData = a;
          this.show = true;
          this.cdr.detectChanges();
          this.GetThisSnapshotTypeData();
        }
      });
    }

    GetThisSnapshotTypeData() {
      this._configService.getSnapshotTypeWidgetDetails({ client_code: this.clientDetails.clientDetails.client_name, snapshot_name: this.clientDetails.clientDetails.study }).subscribe(async (response: any) => {

        this._loaderService.hideLoader();

        if (this._configService.fromBackButton) {
          this._configService.fromBackButton = false;
          // this._configService.WidgetLibSaveDataObject = JSON.parse(JSON.stringify(this._configService.WidgetLibSaveDataObject));
        }
        else {
          if (response.body.Data != null && response.body.Data != undefined && response.body.Data != "") {
            let data = JSON.parse(response.body.Data);
            // this._configService.WidgetLibSaveDataObject = data.filter((m: any) => m.snapshot_type == this.selectedSnapshotType);
          }
        }
        // if (this._configService.WidgetLibSaveDataObject != null && this._configService.WidgetLibSaveDataObject != undefined) {
        //   localStorage.setItem('TotalwidgetDetailss', JSON.stringify(this._configService.WidgetLibSaveDataObject));


        //   // if (localStorage.getItem('TotalwidgetDetailss')) {            
        //   //     this.widgetDetails = JSON.parse(localStorage.getItem('TotalwidgetDetailss') || "");

        //   if ((this._configService.WidgetLibSaveDataObject.length != undefined && this._configService.WidgetLibSaveDataObject.length > 0) || Object.keys(this._configService.WidgetLibSaveDataObject).length > 0) {
        //     this.widgetDetails = this._configService.WidgetLibSaveDataObject;
        //     //this.widgetDetails = this.widgetDetails.filter((m: any) => m.snapshot_type == this._configService.snapshotTypeSelectedName);


        //     this.availableCharts.forEach((chart: any) => {
        //       let count = 0;
        //       if (this.widgetDetails?.WidgetDetail == undefined)
        //         count = this.widgetDetails?.WidgetDetail.filter((m: any) => chart.displayName.trim().replace(/\s+/g, '').toLowerCase() === m.widgetparentchartType.trim().replace(/\s+/g, '').toLowerCase()).length;
        //       else
        //         count = this.widgetDetails?.WidgetDetail.filter((m: any) => chart.displayName.trim().replace(/\s+/g, '').toLowerCase() === m.widgetparentchartType.trim().replace(/\s+/g, '').toLowerCase()).length;
        //       chart.chartSelectedNumber = count > 0 ? count : 0;

        //     });

        //     this.cdr.detectChanges();
        //   }

        // }

        // else {
        //   localStorage.setItem('TotalwidgetDetailss', "");
        // }
        this.enableWidgetsOnStudy();
      });

    }

    getData(): void {
      this._configService.getClientStudyData({ client_code: this.clientDetails.clientDetails.client_name, snapshot_name: this.clientDetails.clientDetails.study }).subscribe((b: any) => {
        if (b.body.Data != null && b.body.Data != undefined && b.body.Data != "") {
          this.snapshotTypeData = JSON.parse(b.body.Data).snapshotType_details;
          Array(this.snapshotTypeData).forEach((item: any) => {
            item.checked = false;
          })
          let snapshotTypeitem = [{
            showDropDown: false,
            checkedList: [],
            options: this.snapshotTypeData
          }]
          this.cdr.detectChanges();
          
          
          
          return snapshotTypeitem;
        }
        else {
          let snapshotTypeitem: never[] = [];
          return snapshotTypeitem;
        }
      }
      );
    }
    expToCollapsable(val: any) {
      this.expandableMenu = !val;
    }
    onChartSelect(chart: any) {
      this.availableCharts.forEach((element: any) => {
        if (element.chartId === chart.chartId) {
          this.updateSelectionDetails(element);
        }
      });
      this.onChartClick.emit("");//notifies parent component when chart is selected

    }
    updateSelectionDetails(selectedChart: LandingCardInterface) {
      this.userSelectionServiceObj.updateUserSelections(selectedChart);//update the userSelections using service
    }

    selectedSnapshotType: any;
    customProperties: any;
  async getSelectedValue(
      option: any,
      value: string,
      item: any,
    ): Promise < void> {
      // if (item.select === 1) {
      option.checked = option.checked == null ? true : !option.checked;
      // If select === 1, treat the checkbox as a radio button
      if(option.checked) {
      // Uncheck previously selected items'
      this.selectedSnapshotType = option.snapshot_type;
      this._configService.snapshotTypeSelectedName = option.snapshot_type;

      item.checkedList = [value];
      item.options.forEach((m: any) => {
        if (m != option) {
          m.checked = false;
        }
      });
    } else {
      // If the radio button is unchecked, remove it from the checkedList
      item.checkedList = [];
    }
    this.GetThisSnapshotData();
  }


  enableWidgetsOnStudy() {
    let i: any[] = [];
    this.commonChartModule.defaultSelectedSnapshotType = this.selectedSnapshotType;
    //this.customProperties\
    
    // this.customProperties?.forEach((item: any) => {
    //   if (item.SnapshotType.trim() == this.selectedSnapshotType) {
    //     i.push(item)
    //   }
    // })
    
    // // this.commonChartModule.widgetsForSelectedSnapType=i;

    // if (i.length > 0) {
    //   this.commonChartModule.updateWidgets(i);
    // } else {
    //   const chartContainer = document.querySelector('.available-charts-tiles');
    //   if (chartContainer) {
    //     chartContainer.innerHTML = 'No Charts Available';
    //   }
    // }

    // let chartGroups = [...new Set(i.map(item => item.ChartGroup))];
    // chartGroups = chartGroups.map(item => item.trim().replace(/\s+/g, '').toLowerCase());
    
    this.availableCharts = LandingConstants.availableCharts;
    this.availableCharts.sort((a: any, b: any) => {
      // Check if sorting is undefined or null for each object
      const aSorting = a.sorting ?? Infinity; // Use Infinity to push missing values to the end
      const bSorting = b.sorting ?? Infinity;
    
      // Sort based on the adjusted sorting values
      return aSorting - bSorting;
    });
    this.availableCharts.forEach((chart: any) => { chart.isAvailable = true; });
    // this.availableCharts.forEach((chart: any) => {
    //   if (!chartGroups.includes(chart.displayName.trim().replace(/\s+/g, '').toLowerCase())) {
    //     chart.isAvailable = false;
    //   }
    // });
    let widgets=this._configCustomService.widgets.filter((w:any)=>w.SnapshotType.replace(/\s+/g, '').toLowerCase()==this._configCustomService.selectedSnapshotType?.name.replace(/\s+/g, '').toLowerCase());
    console.log("Widgets : ",widgets);
    // dummy code //
    this.availableCharts=this.availableCharts.filter((bucket:any)=>{
      return widgets.some((widget: any) =>
        bucket.displayName.trim().replace(/\s+/g, '').toLowerCase()
          ==(widget.ChartGroup.trim().replace(/\s+/g, '').toLowerCase())
      );
    })
    this.updateChartSelectedNumber();

    //this.widgetDetails = JSON.parse(localStorage.getItem('TotalwidgetDetailss') || "");

    // this.widgetDetails = this._configService.WidgetLibSaveDataObject;
    // if (this.widgetDetails != null && this.widgetDetails != undefined && this.widgetDetails.length > 0)
    //   this.widgetDetails = this.widgetDetails.filter((m: any) => m.snapshot_type == this._configService.snapshotTypeSelectedName);

    // if (this.widgetDetails != null && this.widgetDetails != undefined) {
    //   this.availableCharts.forEach((chart: any) => {
    //     let count = 0;
    //     if (this.widgetDetails?.WidgetDetail != undefined)
    //       count = this.widgetDetails?.WidgetDetail.filter((m: any) => chart.displayName.trim().replace(/\s+/g, '').toLowerCase() === m.widgetparentchartType.trim().replace(/\s+/g, '').toLowerCase()).length;
    //     else if (this.widgetDetails?.WidgetDetail != undefined)
    //       count = this.widgetDetails?.WidgetDetail.filter((m: any) => chart.displayName.trim().replace(/\s+/g, '').toLowerCase() === m.widgetparentchartType.trim().replace(/\s+/g, '').toLowerCase()).length;
    //     chart.chartSelectedNumber = count > 0 ? count : 0;

    //   });

    //   this.cdr.detectChanges();
    // }
  }

  async getCustomProperties(): Promise<void> {
    this._configService.getCustomProperties().subscribe(
      (response) => {
        this.customProperties = JSON.parse(response.Data); // Assign the retrieved data to the variable
        // You can perform further operations with this.customProperties here
      },
      (error) => {
        console.error('Error occurred while fetching custom properties:', error);
      }
    );
    return new Promise(resolve => {
      // Perform asynchronous operation
      setTimeout(() => {
        resolve();
      }, 1000);
    });
  }
}